import { getInitialData } from './formator';

const cache = {};

export const getPersonalizedMessages = (touchpointCode) => {
  if (cache[touchpointCode]) {
    return cache[touchpointCode];
  }
  const personalizedMessages = getInitialData().personalizedMessages || [];

  for (let touchpoint of personalizedMessages) {
    if (touchpoint.touchpoint_code === touchpointCode) {
      cache[touchpointCode] = touchpoint;
      return touchpoint;
    }
  }
  return null;
};

export const hasPersonalizedMessages = (touchpointCode) => {
  const touchpoint = getPersonalizedMessages(touchpointCode);
  return touchpoint?.messages[0]?.content?.json;
};
